import { render, staticRenderFns } from "./DepartmentView.vue?vue&type=template&id=55807d92"
import script from "./DepartmentView.vue?vue&type=script&lang=js"
export * from "./DepartmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports